class FullWidthVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.triggerClicked = false
    this.isExternal = this.els.video?.element?.nodeName === 'IFRAME'

    if (this.els?.source?.element?.src != null) {
      this.els.source.elements.forEach(source => {
        source.src = source.dataset.src
      })

      this.els.video.element.load()
    }
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.video?.exists) return

    this.handleClose = this.handleClose.bind(this)

    if (this.els?.trigger?.exists) {
      this.listeners.add(
        this.els.trigger.element,
        'click',
        this.handleTrigger.bind(this),
      )
    }

    this.els.close?.elements?.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.listeners.add(window, 'resize', this.onResize.bind(this))
  }

  onResize () {
    const mediaElement = this.els.mediaContainer?.element

    if (!window.BAO.MediaBreakpoints.isXsViewport) {
      mediaElement.removeAttribute('style')
    } else if (
      this.triggerClicked &&
      this.els.trigger?.element?.hasAttribute('data-no-modal')
    ) {
      mediaElement.style.height = `${this.els.video?.element.clientHeight}px`
    }
  }

  handleTrigger () {
    this.triggerClicked = true

    if (this.els.trigger?.element?.hasAttribute('data-no-modal')) {
      this.els.videoContainer?.element?.setAttribute('aria-hidden', 'false')
      this.els.mediaContainer?.element?.setAttribute('aria-hidden', 'true')
      this.els.content?.element?.setAttribute('aria-hidden', 'true')

      if (window.BAO.MediaBreakpoints.isXsViewport) {
        const mediaElement = this.els.mediaContainer?.element
        mediaElement.style.height = `${this.els.video?.element.clientHeight}px`
      }
    } else {
      this.setAttribute('data-modal-open', 'true')
      document.body.classList.toggle('util-SiteOverflowed', true)
      this.els.modal?.element?.setAttribute('aria-hidden', 'false')
    }

    if (!this.els.source?.element?.src && !this.isExternal) {
      this.els.source.element.src = this.els.source.element.dataset.src
      this.els.video.element.load()
    }

    if (!this.isExternal) {
      this.els.video?.element?.play()
    }
  }

  handleClose () {
    this.els.modal.element.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    const restartVideo = this.els.video.element.src

    this.isExternal
      ? (this.els.video.element.src = restartVideo)
      : this.els.video.element.pause()
  }
}

if (!customElements.get('full-width-video')) {
  customElements.define('full-width-video', FullWidthVideo)
}
